import React, { Component } from 'react';
import { connect } from 'react-redux';
import ItemWithUtil from './ItemWithUtil';
import { formatPrice } from 'utils';
import { BASE_URL } from 'constants/index';
import { addProductToCart } from './actions';

class ItemCatalog extends Component {
    handleAddToCartClick = event => {
        const { productSku } =
            event.currentTarget.dataset || event.srcElement.dataset;

        this.props.addProductToCart(this.props.cartId, productSku);
    };

    render() {
        const {
            productDescription,
            product,
            productImage,
            formClassName
        } = this.props;

        return (
            <div className={formClassName('wrapper')}>
                <div className={formClassName('image')}>
                    <img
                        src={`${BASE_URL}pub/media/catalog/product${productImage}`}
                        alt={product.name}
                    />
                </div>
                <div className={formClassName('content')}>
                    <div
                        className={formClassName('description')}
                        dangerouslySetInnerHTML={{
                            __html: productDescription
                        }}
                    />

                    <p className={formClassName('price')}>
                        {formatPrice(product.price)}
                    </p>

                    <button
                        className={formClassName('button')}
                        onClick={this.handleAddToCartClick}
                        type="button"
                        data-product-sku={product.sku}
                    >
                        Add To cart
                    </button>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    const { cartId } = state.cartReducer;

    return {
        cartId: cartId
    };
};

const mapDispatchToProps = dispatch => {
    return {
        addProductToCart: (cartId, productSku) =>
            dispatch(addProductToCart(cartId, productSku))
    };
};

export default ItemWithUtil(
    connect(mapStateToProps, mapDispatchToProps)(ItemCatalog),
    'catalogList'
);



// WEBPACK FOOTER //
// ./src/components/ProductItem/ItemCatalog.jsx